module.exports = __webpack_public_path__ + "img/mjmgyygyh-en.0184f5a9.png";